import React from 'react'
import { useDispatch } from 'react-redux'
import { removeTemporarilyAddedPriceForItem, resetOrderInBucket } from '../../../redux/slices/itemCustomizationSlice'
import { itemBuckets } from '../../../priceCalculation/buckets'
import styleClasses from './itemBox.module.scss'

interface ISelectedItemsBox{
    orderedIngredients:any[];
    isItMobile:Boolean;
    showModifierModal:() => void;
    setFirstTimeModal: (state:boolean) => void;
}

const ItemsBox: React.FC<ISelectedItemsBox> = (props) => {
  const {orderedIngredients=[], isItMobile, showModifierModal, setFirstTimeModal} = props;
  const dispatch = useDispatch()

  const resetHandler = () => {
    dispatch(
      removeTemporarilyAddedPriceForItem({
        price: itemBuckets.removeAddedModifiersInCreateYourOwnSalad(1),
        item: 1,
      })
    );
    dispatch(resetOrderInBucket({itemNo: "1"}))
    itemBuckets.removeModifiersfromBucket(1)
  }

  const onEditClickHandler = () => {
    if(!isItMobile){
      setFirstTimeModal(true)
    }
    showModifierModal()
  }
  return (
    <React.Fragment>
      <div className="bg-white rounded-3 modifiers-box text-start py-4 ps-4 pe-md-4 pe-2 my-4 position-relative">
          <div className={styleClasses.edit_btn}>
            <button
              type="button"
              className="btn btn-custom text_underline p-0 ms-3 f-s14 edit-action-btn-for-all-screens"
              onClick={onEditClickHandler}
            ></button>
          </div>
        <div className={`${isItMobile ? 'modifiers-listing' : 'modifiers-scroll'}`}>
          {orderedIngredients?.map((item) => {
            return (
              <div key={'parent'+item.modifier_id} className={`${styleClasses.select_modifier_lisiting} d-flex align-items-center`}>
                <div
                  className={`${styleClasses.selected_modifier_image}`}
                >
                  <img
                    src={item?.image}
                    alt={item?.modifier_name}
                  />
                </div>
                <div
                  className="font-Visby-cf f-s14 fw-bold lh-lg"
                  key={item.modifier_id}
                >
                  {item?.modifier_name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};


export default ItemsBox